<form nz-form [formGroup]="billingFilterForm">
    <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">

        <div nz-col *ngIf="billingFilterForm.controls['Timeframe']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Timeframe'">
                    <nz-select formControlName="Timeframe" class="filters" id="Timeframe" nzPlaceHolder="Timeframe"
                        nzShowSearch style="width: 100%;">
                        @for(opt of loopback; track $index) {
                        <nz-option [nzLabel]="'Last ' + opt.val" [nzValue]="opt.val"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>


        <div nz-col *ngIf="billingFilterForm.controls['status']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a status'">
                    <nz-select formControlName="status" class="filters" id="status" nzPlaceHolder="Status" nzShowSearch
                        nzAllowClear style="width: 100%;">
                        @for(opt of statusList; track $index){
                        <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['batchId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a batch Id'">
                    <nz-select formControlName="batchId" class="filters" id="batchId" nzPlaceHolder="Batch Id"
                        nzShowSearch nzAllowClear style="width: 100%;">
                        @for(opt of batchIds; track $index){
                        <nz-option [nzLabel]="opt.billingId" [nzValue]="opt.billingId"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['fileName']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a file Name'">
                    <nz-select formControlName="fileName" class="filters" id="fileName" nzPlaceHolder="File Name"
                        nzShowSearch nzAllowClear style="width: 100%;">
                        @for(opt of fileNames; track $index){
                        <nz-option [nzLabel]="opt.fileName" [nzValue]="opt.fileName"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['consumerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Consumer PPL ID'">
                    <input placeholder="Consumer PPL ID" nz-input (input)="onInput($event, 'consumerPplId')"
                        formControlName="consumerPplId" id="consumerPplId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['mcoId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
            [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a MCO Id'">
                    <input placeholder="MCO Id" nz-input (input)="onInput($event, 'mcoId')" formControlName="mcoId"
                        id="mcoId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['medicaidId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a CIN'">
                    <input placeholder="CIN" nz-input (input)="onInput($event, 'medicaidId')"
                        formControlName="medicaidId" id="medicaidId" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['serviceDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Service Date'">
                    <nz-date-picker formControlName="serviceDate" id="serviceDate" [nzFormat]="'MM/dd/yyyy'"
                        [nzPlaceHolder]="'Service Date'"></nz-date-picker>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['payerName']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter a payer name'">
                    <input nz-input formControlName="payerName" id="payerName" placeholder="Payer Name" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['pmpm']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
            [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a value'">
                    <nz-select formControlName="pmpm" class="filters" id="pmpm" nzPlaceHolder="PMPM" nzShowSearch
                        nzAllowClear style="width: 100%;">
                        @for(opt of pmpmOptions; track $index){
                        <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="text-align: right; margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="search()"></ppl-button>
            </nz-form-item>
        </div>

    </div>
</form>